import * as DOCTOR from '@/store/constants/doctor';

export default {
  [DOCTOR.GET_DOCTOR_LIST]: (state) => {
    return state.list;
  }
}


// WEBPACK FOOTER //
// ./src/store/doctor/getters.js